import React, { useMemo } from 'react';
import { useField } from 'react-final-form';

import {
  AlignHorizontalLeftOutlined,
  AlignHorizontalRightOutlined,
  AlignVerticalBottomOutlined,
  AlignVerticalTopOutlined,
} from '@mui/icons-material';
import { InputLabel, Stack } from '@mui/material';

import RawSliderInput from '../raw/RawSliderInput';

type Props = {
  label: string;
  name: string;
};
export default function Padding({ label, name }: Props) {
  const { value, onChange } = useField<string>(name).input;

  const values = useMemo(() => {
    if (!value) {
      return { top: 0, left: 0, right: 0, bottom: 0 };
    }
    if (value.trim().length === 0) {
      return { top: 0, left: 0, right: 0, bottom: 0 };
    }

    const v = value.split(/\s+/).map((val) => {
      const num = parseInt(val.replace('px', ''), 10);
      return isNaN(num) ? 0 : num;
    });

    if (v.length === 1) {
      return { top: v[0], right: v[0], bottom: v[0], left: v[0] };
    }
    if (v.length === 2) {
      return { top: v[0], right: v[1], bottom: v[0], left: v[1] };
    }
    if (v.length === 3) {
      return { top: v[0], right: v[1], bottom: v[2], left: v[1] };
    }
    return { top: v[0], right: v[1], bottom: v[2], left: v[3] };
  }, [value]);

  function handleChange(internalName: string, value: number) {
    const newValue = { ...values, [internalName]: value };
    onChange(`${newValue.top}px ${newValue.right}px ${newValue.bottom}px ${newValue.left}px`);
  }

  return (
    <Stack spacing={2} alignItems="flex-start" pb={1}>
      <InputLabel shrink>{label}</InputLabel>

      <RawSliderInput
        label={<AlignVerticalTopOutlined sx={{ fontSize: 16 }} />}
        value={values.top}
        onChange={(num) => handleChange('top', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        label={<AlignVerticalBottomOutlined sx={{ fontSize: 16 }} />}
        value={values.bottom}
        onChange={(num) => handleChange('bottom', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        label={<AlignHorizontalLeftOutlined sx={{ fontSize: 16 }} />}
        value={values.left}
        onChange={(num) => handleChange('left', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />

      <RawSliderInput
        label={<AlignHorizontalRightOutlined sx={{ fontSize: 16 }} />}
        value={values.right}
        onChange={(num) => handleChange('right', num)}
        units="px"
        step={4}
        min={0}
        max={80}
        marks
      />
    </Stack>
  );
}
